/**
 * 위해도 등급 → 배지 스타일 (F5 · 2026-08-14).
 *
 * **결함.** 이 매핑은 `"very_high"` 와 비교하고 있었는데 그런 값은 나오지
 * 않았고, 실제로 나오던 최고 등급 `"critical"` 은 어느 분기에도 걸리지 않아
 * **안전(초록)으로 표시**됐다. 등급 필드가 `str` 이라 아무 곳에서도 예외가
 * 나지 않아 조용히 어긋난 상태였다(T1 수정기록 §5 F4·F5).
 *
 * 표준 어휘는 백엔드 `app.services.hazard_assessment.HazardLevel` 이다:
 * `none` / `low` / `moderate` / `high` / `extreme`.
 *
 * 모르는 값이 오면 안전 쪽으로 낮추지 않는다 — 위해도에서 미지의 값을
 * "안전"으로 처리하면 결함이 다시 조용해진다.
 */

export type RiskBadgeTone = "danger" | "warning" | "safe" | "unknown";

/** 백엔드 HazardLevel 어휘. 이 목록에 없으면 unknown 이다. */
const DANGER: ReadonlySet<string> = new Set(["high", "extreme"]);
const WARNING: ReadonlySet<string> = new Set(["moderate"]);
const SAFE: ReadonlySet<string> = new Set(["none", "low"]);

export function riskBadgeTone(level: string | null | undefined): RiskBadgeTone {
  if (!level) return "unknown";
  const normalised = level.toLowerCase();
  if (DANGER.has(normalised)) return "danger";
  if (WARNING.has(normalised)) return "warning";
  if (SAFE.has(normalised)) return "safe";
  return "unknown";
}

const TONE_CLS: Record<RiskBadgeTone, string> = {
  danger: "bg-red-100 text-red-700",
  warning: "bg-yellow-100 text-yellow-700",
  safe: "bg-green-100 text-green-700",
  // 미지의 등급은 초록(안전)으로 두지 않는다. 회색 = 판정 불가.
  unknown: "bg-gray-200 text-gray-700",
};

export function riskBadgeClass(level: string | null | undefined): string {
  return TONE_CLS[riskBadgeTone(level)];
}
